import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromUnit from './unit';
import * as fromRoot from '../../reducers';

export interface UnitState {
  unit: fromUnit.State;
}

export interface State extends fromRoot.State {
  unit: UnitState;
}

export const reducers = {
  unit: fromUnit.unitReducer,
};

export const getUnitsState = createFeatureSelector<UnitState>('unit');

export const getUnitState = createSelector(
  getUnitsState,
  state => state.unit
);

export const selectUnit = createSelector(
  getUnitState,
  fromUnit.getSelectedUnit
);
export const selectUnits = createSelector(
  getUnitState,
  fromUnit.getUnits
);
export const selectUnitUsers = createSelector(
  getUnitState,
  fromUnit.getUnitUsers
);
export const selectUnitErrors = createSelector(
  getUnitState,
  fromUnit.getUnitsErrors
);
export const selectUnitEmployment = createSelector(
  getUnitState,
  fromUnit.getSelectedUnitEmployment
);
